import { BASE_URL } from "@constants/common";
import { Product } from "@typings/product/product";
import { buildSharedCartUrl } from "@helpers/cart/shareableCart";

export const transformCartItemsToUrl = (
  cartItems: Product[],
  path: "/cart" | "/checkout" = "/cart"
) => {
  const baseUrl = `${BASE_URL}${path}`;

  return buildSharedCartUrl(baseUrl, cartItems);
};
